import React, { Component } from 'react'
import Videos from "./../../containers/Video/Videos";
class Page_video extends Component{
    constructor(props) {
        super(props);
        this.state = {
            channel_id: 0
        }
    }

    onChange = (e) => {
        this.setState({
            channel_id: e.target.value
        })
    }

    componentWillReceiveProps(nextProps) {
        let channels = nextProps.channels.channels;
        this.setState({
            channel_id: channels[0].id
        })
    }

    render(){
        if (this.props.channels.loading) {
            return 'Loading...';
        }

        if (this.props.channels.error) {
            return 'Fetch data error';
        }

        let tvChannelList = this.props.channels.channels;
        let tvChannelListElement = tvChannelList.map(channel => {
            return (
                <option key={channel.id} value={channel.id}>{channel.name}</option>
            )
        });
        return (
            <div className="all-video">
                <div className="container">
                    <div className="clearfix top-control">
                        <div className="pull-left">
                            <ul className="breadcrumbs list-inline marginB0">
                                <li>
                                    Kênh TV <span>/</span>
                                </li>
                                <li className="active">Video mới</li>
                            </ul>
                        </div>
                        <div className="pull-right">
                            <select value={this.state.channel_id} onChange={this.onChange} className="slect">
                                {tvChannelListElement}
                            </select>
                        </div>
                    </div>
                    <Videos channel_id={this.state.channel_id}/>
                </div>
            </div>
        )
    }
}
export default Page_video



// WEBPACK FOOTER //
// ./src/components/Video/Page_video.js